import { render, staticRenderFns } from "./Standing.vue?vue&type=template&id=8d0a6562&scoped=true&"
import script from "./Standing.vue?vue&type=script&lang=js&"
export * from "./Standing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0a6562",
  null
  
)

export default component.exports